import Topbar from "./scenes/global/Topbar";
import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import Footer from "./components/Footer";
import axios from 'axios';
import { API_URL } from "./api-config";
import RouterComponent from "./components/RouterComponent";
import "react-toastify/dist/ReactToastify.minimal.css";
import { injectStyle } from "react-toastify/dist/inject-style";
import { ToastContainer} from 'react-toastify';
import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
// import { useLocation } from 'react-router-dom'; 
import './App.css'

function App() {
  const [theme, colorMode] = useMode();
  const [token, setToken] = useState(localStorage.getItem("token"))
  const [email, setEmail] = useState("")
  const [type, setType] = useState("")


  injectStyle();
  
  useEffect(() => {


    const checkTokenValidity = () => {
        if (token === null) {
            window.location.assign("/");
            return;
        }
        axios.get(`${API_URL}/users-api/me`, {
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + token,
            }
        }).then((response) => {
            if (response.status === 401) {
                // Usamos console.warn para evitar que aparezca como un error crítico
                console.warn('Unauthorized: Token might be invalid or expired');
                setToken(null);
                localStorage.removeItem("token");
                window.location.assign("/signin");
            }
            const valid_token = response.data.valid_token;
            
            setEmail(response.data.email)
            
            
        
            setType(response.data.type)
            setToken(token)
        
            if (token !== valid_token) {
                setToken(null);
                localStorage.removeItem("token");
                window.location.assign("/");
            }
        }).catch((error) => {
            if (error.response) {
                if (error.response.status === 401) {
                    // Usamos console.warn para evitar que aparezca como un error crítico
                    console.warn('Unauthorized: Token might be invalid or expired');
                    setToken(null);
                    localStorage.removeItem("token");
                    window.location.assign("/signin");
                } else {
                    // Puedes cambiar este log dependiendo de tu necesidad
                    console.warn('Request failed with status', error.response.status);
                }
            } else {
                // Otros errores que no sean relacionados a la respuesta del servidor
                console.warn('Error', error.message);
            }
        });
        
    };
    const intervalId = setInterval(checkTokenValidity, 5 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, []);

  let location = useLocation();
  const rutaSixbell = "/sixbell_bi";
  const rutaCheil = "/cheil_bi/1"
  const esRutaEspecial = location.pathname === rutaSixbell || location.pathname === rutaCheil;

  return (
    <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <div className="App w-screen flex flex-col">
                {token === null && esRutaEspecial ? (
                    <></>
                ) : (
                    <Topbar id="header" token={token} setToken={setToken}  />
                )}
                
                <div className="">
                    <ToastContainer />
                    {token === null ? (
                        <RouterComponent token={null} email={email} theme={theme} type={type} />
                    ) : (
                        <>
                            <RouterComponent token={token} email={email} theme={theme} type={type} />
                        </>
                    )}
                </div>
                {!esRutaEspecial ? (
                    <div className="sticky-footer  bottom-0">
                        <Footer />
                    </div>
                ) : null}
            </div>
        </ThemeProvider>
    </ColorModeContext.Provider>

  );
}

export default App;